module.exports = __webpack_public_path__ + "static/media/SWSCRC1-06.ae4a4854.mp3";